<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-toolbar-title class="headline text-uppercase">
        <v-col>
          <div class="sub-title">水防災オープンデータ配信システム</div>
          <div class="main-title">運用管理画面</div>
        </v-col>
      </v-toolbar-title>
      <v-spacer />
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text class="login-btn" style="text-transform: none" v-on="on">
            <v-icon>person</v-icon>
            {{ userName }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="logout">
            <v-list-item-title>ログアウト</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <router-view :key="$route.path" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import loginModule from "../store/LoginModule";

@Component
export default class DefaultLayout extends Vue {
  get userName(): string {
    if (loginModule.userName === "") {
      return "no-name";
    } else {
      return loginModule.userName;
    }
  }

  async logout() {
    await loginModule.reset();
    await this.$router.push({ name: "Login" });
  }
}
</script>

<style lang="scss">
* :not(.v-icon) {
  font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ",
    Meiryo, "ＭＳ Ｐゴシック", sans-serif !important;
}
.sub-title {
  margin-top: -4px;
  font-weight: bold;
  font-size: 9pt;
}
.main-title {
  margin-top: -12px;
  font-weight: 900;
  font-size: 20pt;
}
</style>
